"use strict";

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { camelCase } from 'camel-case';
import { upperCaseFirst } from 'upper-case-first';
const transformerFnMap = {
  camel: camelCase,
  upperFirst: upperCaseFirst
};
export const toCasedKeys = (object, caseType) => {
  let casedObject;
  const transformer = transformerFnMap[caseType];
  if (Array.isArray(object)) {
    casedObject = object.map(value => {
      if (typeof value === 'object') {
        value = toCasedKeys(value, caseType);
      }
      return value;
    });
    return casedObject;
  }
  casedObject = {};
  const objectKeys = Object.keys(object);
  for (const origKey in object) {
    if (objectKeys.includes(origKey)) {
      let value = object[origKey];
      if (Array.isArray(value) || value !== null && value.constructor === Object) {
        value = toCasedKeys(value, caseType);
      }
      casedObject[transformer(origKey)] = value;
    }
  }
  return casedObject;
};
export const toCamelCaseKeys = object => toCasedKeys(object, 'camel');
export const toUpperCaseFirstKeys = object => toCasedKeys(object, 'upperFirst');